module.exports = __webpack_public_path__ + "assets/img/kv-3e7e57f6.jpg";